export const DARKMODE = '@@common/DarkMode';
export const TOGGLEMENU = '@@common/ToggleMenu';